import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  GetOrchSurveyResponse,
  GetSurveySurveyCodeEnum,
  QineticSurveyApi,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const getAdvQuestionnaires = createAsyncThunk<
  GetOrchSurveyResponse,
  { surveyCode: GetSurveySurveyCodeEnum; fiscalCode?: string },
  ThunkApi
>(
  "getAdvQuestions",
  async ({ surveyCode, fiscalCode }, { getState, rejectWithValue }) => {
    try {
      if (!fiscalCode) {
        const {
          customer: { personalInfo },
        } = getState();
        fiscalCode = personalInfo.fiscalCode;
      }

      const { data } = await new QineticSurveyApi().getSurvey(
        fiscalCode,
        surveyCode,
      );

      return data;
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Recupero ADV",
        description:
          "Non siamo riusciti a recuperare le domanda riguardanti ADV.\n Puoi riprovare o contattare il supporto",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
